import { useDispatch, useSelector } from "react-redux";
import { Appstore } from "../../redux";
import { useEffect, useState } from "react";
import { SetContentGeneralTopics } from "../../redux/catalogs/states";
import { getContentGeneralTopics } from "../../Services/ContentGeneralTopic";

const UseContentGeneralTopicList = () => {
  const [isFetching, setIsFetching] = useState(true)

  const dispatch = useDispatch();
  const contentGeneralTopicsData = useSelector((state: Appstore) => state.contentGeneralTopics);

  const resetContentGeneralTopics = () => {
    setIsFetching(true)
  }

  useEffect(() => {
      if (contentGeneralTopicsData.length) {
        setIsFetching(false)
        return
      }
      if (!isFetching) {
        return
      }

      getContentGeneralTopics()
      .then((response) => {
        dispatch(SetContentGeneralTopics(response))
        if (!response.length) {
          console.error('No general topics found. Please check the data source.')
        }
      })
      .catch((error) => console.error(error))
      .finally(() => setIsFetching(false))
  }, [isFetching]);

  return {contentGeneralTopicsData, isFetching,resetContentGeneralTopics};
};

export {UseContentGeneralTopicList}
